import React, { Fragment, PureComponent } from 'react'
import PageLayout from './PageLayout'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Helmet from 'react-helmet'
import Breadcrumb from '../common/Breadcrumb'
import GroupWidget from '../common/GroupWidget'
import Share from '../share/Share'
import richTextOptions from '../../utils/richTextReactRendering'
import { withScrollContext, withPopupContext } from '../../contexts'
import filter from 'lodash/filter'
import map from 'lodash/map'
import get from 'lodash/get'
import isUndefined from 'lodash/isUndefined'
import { Link, scroller } from 'react-scroll'
import { isObject } from 'lodash'
import MobileHeader from '../common/MobileHeader'
import { MobileFloatingBar } from './index'
import VideoBackgroundWidget from '../widgets/VideoBackgroundWidget'

class GenericLayout extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            isSearchFocus: false,
            isOverlayActive: false,
            popupShowing: null,
            guidelineContent: null,
            isMobile: false,
        }
    }

    componentDidMount() {
        this.setState({
            isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
        })
        const { location, offset } = this.props
        const hash = get(location, 'hash')
        if (hash) {
            const anchor = location.hash.split('#')
            scroller.scrollTo(anchor[1], {
                duration: 1500,
                delay: 100,
                smooth: 'easeInCubic',
                containerId: anchor[1],
                offset,
            })
        }
        setTimeout(() => {
            const mobileFloatingBar = !isUndefined(document) && document.querySelector('#mobile-floating-bar')
            const topPos = this.state.isMobile ? mobileFloatingBar.offsetTop : 160
            this.props.scroll.setTopPos(topPos)
        }, 1500)

        setTimeout(() => {
            const appFooterTop = !isUndefined(document) && document.querySelector('.richtext-body').offsetTop - window.innerHeight + 220

            this.props.scroll.setTopPos(appFooterTop)
        }, 5000)

        setTimeout(() => {
            const appFooterTop = !isUndefined(document) && document.querySelector('.app-footer').offsetTop - window.innerHeight + 220

            this.props.scroll.setBotPos(appFooterTop)
        }, 5000)
    }

    renderSidebar() {
        const { page, preview, offset } = this.props
        const body = !preview ? JSON.parse(page.richText.childContentfulRichText.internal.content) : page.richText
        const content = documentToReactComponents(body, richTextOptions)
        const indexes = filter(content, (c) => c.type === 'h3')
        return (
            <>
                <h5>Within this Page</h5>
                <ul className={'page-index'}>
                    {map(indexes, (index, i) => {
                        const heading = index.props.children
                        return (
                            <li key={index.props.id} className="item" title={index.text}>
                                <Link activeClass={'active'} to={index.props.id} spy={true} smooth={true} offset={offset}>
                                    {map(heading, (h, j) => {
                                        if (isObject(h)) {
                                            return h.props.children
                                        }
                                        return h
                                    })}
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </>
        )
    }

    render() {
        const { site, page, hasGroup, preview, scroll, sitemap, className } = this.props
        const activeSection = page ? page.userSection : ''
        const metaDescription = page ? page.metaDescription : null
        const summary = page ? page.summary : null
        const body = !preview ? JSON.parse(page.richText.childContentfulRichText.internal.content) : page.richText
        const floatingClass = scroll.isReadingContent ? 'floating' : ''
        const doneClass = scroll.isBottomReached ? 'done' : ''
        const openClass = scroll.isHeaderOpen ? 'open' : ''
        const isReading = scroll.isReadingContent
        const backgroundUrl = get(page, 'heroImage.file.url', '')
        const backgroundVideoUrl = get(page, 'heroVideo', '')
        const backgroundGradient = 'linear-gradient(rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.35) 100%)'
        const backgroundTitle = get(page, 'heroImage.title', '')
        const fullWidth = get(page, 'heroImageFullWidth')
        const _window = typeof window !== 'undefined' && window
        const isIE11 = !!_window.MSInputMethodContext && !!document.documentMode
        const renderImage = () => {
            if (backgroundUrl) {
                return <div className="story-hero-banner" role="img" aria-label={backgroundTitle} style={{ backgroundImage: `${backgroundGradient}, url(${backgroundUrl})` }} />
            }
        }
        const renderHero = () => {
            if (isIE11) {
                return renderImage()
            }
            if (backgroundVideoUrl) {
                return (
                    <div className="hero-content">
                        <VideoBackgroundWidget url={backgroundVideoUrl} />
                    </div>
                )
            }
            return renderImage()
        }

        return (
            <PageLayout className={`generic-page ${className} `} activeSection={activeSection} sitemap={sitemap} openClass={openClass} isReading={isReading}>
                {page && (
                    <Fragment>
                        <Helmet>
                            <title>
                                {site.title} - {page.title}
                            </title>
                            <meta property="og:url" content={`${site.siteUrl}/${page.slug}`} />
                            <meta property="og:type" content="article" />
                            <meta property="og:title" content={`${site.title} - ${page.title}`} />
                            {(!!metaDescription || !!summary) && <meta name="description" content={metaDescription ? metaDescription.metaDescription : summary.summary} />}
                        </Helmet>
                        <div className={fullWidth === true || typeof fullWidth === 'undefined' ? '' : 'no-full-width'}>{renderHero()}</div>
                        <Breadcrumb page={page} params={this.props.location?.state?.params} />
                        <main className={`wrapper ${floatingClass} with-sidebar`}>
                            <MobileFloatingBar isFixedIndex={scroll.isReadingContent && scroll.isFixedIndex} isHeaderOpen={scroll.isHeaderOpen} activeSection={activeSection} noPopup={true}>
                                <MobileHeader propParent={this.props} className={'innerWrapper'} trim={true} />
                            </MobileFloatingBar>
                            <aside className={`sidebar ${doneClass} sidebar-generic`}>
                                <div className="sidebar-box">
                                    {hasGroup && <GroupWidget inSidebar preview={preview} groups={page.groups} />}
                                    {this.renderSidebar()}
                                </div>
                            </aside>
                            <div className="content">
                                <h1 className="section-headline">{page.title}</h1>
                                <div className="richtext-body">{body && documentToReactComponents(body, richTextOptions)}</div>
                            </div>
                        </main>
                        {page.showSocialShare && (
                            <div className={`share-section${hasGroup ? ' wide' : ''}`}>
                                <div className="wrapper">
                                    <Share
                                        socialConfig={{
                                            twitterHandle: site.twitterHandle,
                                            config: {
                                                url: `${site.siteUrl}/${page.slug}`,
                                                title: `${site.title} - ${page.title}`,
                                            },
                                        }}
                                        tags={['Starship']}
                                    />
                                </div>
                            </div>
                        )}
                    </Fragment>
                )}
            </PageLayout>
        )
    }
}

export default withPopupContext(withScrollContext(GenericLayout))
